import { Alert } from '@mui/material';

export default function Callout({ type = "info", children }) {
  return (
    <Alert
      severity={type}
      sx={{
        my: 2,
        borderRadius: 2,
        alignItems: "center",         
        "& .MuiAlert-message": {
          display: "flex",
          alignItems: "center",
        },
      }}
    >
      {children}
    </Alert>
  );
}
